import React, { useState } from 'react';
import { View, Text, Alert, ScrollView } from 'react-native';
import { supabase } from '../services/supabaseClient';
import { CustomInput } from '../components/CustomInput';
import { CustomButton } from '../components/CustomButton';
import { colors, globalStyles } from '../styles/global';

export const LoginScreen = ({ navigation }) => {
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    whatsapp: '',
    cpf: '',
    password: '',
    confirmPassword: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
    setError('');
  };

  const validateForm = () => {
    if (!isLogin) {
      if (!formData.name.trim()) {
        setError('Nome é obrigatório');
        return false;
      }
      if (!formData.cpf.trim() || formData.cpf.length !== 14) {
        setError('CPF inválido');
        return false;
      }
      if (!formData.whatsapp.trim() || formData.whatsapp.length !== 15) {
        setError('WhatsApp inválido');
        return false;
      }
      if (formData.password !== formData.confirmPassword) {
        setError('As senhas não coincidem');
        return false;
      }
    }
    if (!formData.email.trim() || !formData.email.includes('@')) {
      setError('E-mail inválido');
      return false;
    }
    if (!formData.password || formData.password.length < 6) {
      setError('A senha deve ter pelo menos 6 caracteres');
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    setLoading(true);
    try {
      if (isLogin) {
        const { error, data } = await supabase.auth.signInWithPassword({
          email: formData.email,
          password: formData.password,
        });
        if (error) throw error;
        navigation.navigate('Dashboard');
      } else {
        const { error } = await supabase.auth.signUp({
          email: formData.email,
          password: formData.password,
          options: {
            data: {
              name: formData.name,
              whatsapp: formData.whatsapp,
              cpf: formData.cpf,
            },
          },
        });
        if (error) throw error;
        Alert.alert('Sucesso', 'Verifique seu e-mail para confirmar o cadastro');
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async () => {
    if (!formData.email.trim() || !formData.email.includes('@')) {
      setError('Digite um e-mail válido para redefinir a senha');
      return;
    }

    setLoading(true);
    try {
      const { error } = await supabase.auth.resetPasswordForEmail(formData.email);
      if (error) throw error;
      Alert.alert('Sucesso', 'Verifique seu e-mail para redefinir a senha');
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ScrollView
      contentContainerStyle={[globalStyles.container, globalStyles.centerContent]}
      keyboardShouldPersistTaps="handled"
    >
      <Text style={globalStyles.title}>
        {isLogin ? 'Login' : 'Criar Conta'}
      </Text>

      {error ? <Text style={globalStyles.errorText}>{error}</Text> : null}

      {!isLogin && (
        <CustomInput
          placeholder="Nome completo"
          value={formData.name}
          onChangeText={(text) => handleInputChange('name', text)}
          autoCapitalize="words"
        />
      )}

      <CustomInput
        placeholder="E-mail"
        value={formData.email}
        onChangeText={(text) => handleInputChange('email', text)}
        keyboardType="email-address"
        autoCapitalize="none"
      />

      {!isLogin && (
        <>
          <CustomInput
            placeholder="WhatsApp"
            value={formData.whatsapp}
            onChangeText={(text) => handleInputChange('whatsapp', text)}
            keyboardType="phone-pad"
            maskType="phone"
          />

          <CustomInput
            placeholder="CPF"
            value={formData.cpf}
            onChangeText={(text) => handleInputChange('cpf', text)}
            keyboardType="numeric"
            maskType="cpf"
          />
        </>
      )}

      <CustomInput
        placeholder="Senha"
        value={formData.password}
        onChangeText={(text) => handleInputChange('password', text)}
        secureTextEntry
      />

      {!isLogin && (
        <CustomInput
          placeholder="Confirmar senha"
          value={formData.confirmPassword}
          onChangeText={(text) => handleInputChange('confirmPassword', text)}
          secureTextEntry
        />
      )}

      <CustomButton
        title={loading ? 'Carregando...' : isLogin ? 'Entrar' : 'Cadastrar'}
        onPress={handleSubmit}
        disabled={loading}
      />

      <Text
        style={globalStyles.link}
        onPress={() => setIsLogin(!isLogin)}
      >
        {isLogin ? 'Criar uma conta' : 'Já tenho uma conta'}
      </Text>

      {isLogin && (
        <Text
          style={globalStyles.link}
          onPress={handleResetPassword}
        >
          Esqueci minha senha
        </Text>
      )}
    </ScrollView>
  );
};